export default "__VITE_ASSET__DaRxGHsv__"